/* Scroll-triggered word/block reveal, for reuse across sections.
 * Deliberately separate from the hero's own reveal system (aphelion-hero.js),
 * which is driven by video playback position rather than scroll position and
 * has its own tuned bug-fix history - see aphelion-hero.css's header comment.
 *
 * Markup contract:
 *   [data-reveal-group]                      the section/wrapper to observe
 *     [data-reveal]                          fades in as a block, OR
 *     [data-reveal][data-reveal-split]       text splits into per-word spans
 *     [data-reveal][data-reveal-split="blur"] same, with a blur-in variant
 *
 * Optional attributes on the group: data-reveal-threshold (0-1, default 0.2),
 * data-reveal-step (ms between cascaded elements, default 90).
 */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function splitWords(el) {
    if (el.hasAttribute('data-reveal-done')) return;
    var text = el.textContent;
    if (!text || !text.trim()) return;
    var frag = document.createDocumentFragment();
    var i = 0;
    text.split(/(\s+)/).forEach(function (chunk) {
      if (!chunk) return;
      if (/^\s+$/.test(chunk)) {
        frag.appendChild(document.createTextNode(chunk));
        return;
      }
      var span = document.createElement('span');
      span.className = 'aph-word';
      span.style.setProperty('--i', i++);
      span.textContent = chunk;
      frag.appendChild(span);
    });
    el.textContent = '';
    el.appendChild(frag);
    el.setAttribute('data-reveal-done', '');
  }

  function setupGroup(group) {
    if (group.hasAttribute('data-reveal-ready')) return;
    group.setAttribute('data-reveal-ready', '');

    var targets = [].slice.call(group.querySelectorAll('[data-reveal]'));
    if (!targets.length) return;

    targets.forEach(function (el) {
      if (el.hasAttribute('data-reveal-split')) splitWords(el);
    });

    if (reduced) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var step = parseInt(group.getAttribute('data-reveal-step'), 10) || 90;
    var threshold = parseFloat(group.getAttribute('data-reveal-threshold')) || 0.2;

    function run() {
      targets.forEach(function (el, i) {
        setTimeout(function () { el.classList.add('is-in'); }, i * step);
      });
    }

    if (!('IntersectionObserver' in window)) {
      run();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          run();
          io.unobserve(group);
        }
      });
    }, { threshold: threshold, rootMargin: '0px 0px -8% 0px' });

    io.observe(group);
  }

  function init() {
    var groups = document.querySelectorAll('[data-reveal-group]');
    for (var i = 0; i < groups.length; i++) setupGroup(groups[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
